import { PropsWithChildren } from 'react'
import Modal from 'react-modal'
import { BaseModalProps } from 'src/types/modal'

type ActionFcResult = (Promise<void | boolean> | (void | boolean));

interface ConfirmationModalProps extends BaseModalProps, PropsWithChildren {
  title?: string
  confirmLabel?: string
  cancelLabel?: string
  isLoading?: boolean
  confirmDisabled?: boolean
  onConfirm: () => ActionFcResult
  onCancel?: () => ActionFcResult
}

const ConfirmationModal = ({
  isOpen,
  title,
  children,
  isLoading,
  confirmDisabled,
  cancelLabel, confirmLabel,
  onClose, onCancel, onConfirm,
}: ConfirmationModalProps) => {
  const handleAction = async (actionFc?: () => ActionFcResult) => {
    if (actionFc) {
      const state = await actionFc()
      if (typeof state === 'boolean' && !state) return
    }
    onClose()
  }
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      className="modal-popup confirm-popup"
      overlayClassName="modal-overlay"
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onAfterClose={() =>
        document.body.classList.remove('ReactModal__Body--open')
      }
    >
      <div className="modal-content-wrapper">
        <h2>{title ?? 'Action Confirmation'}</h2>
        {isLoading && (
          <div className="loader-wrapper">
            <div className="loader"></div>
          </div>
        )}
        <div>{children}</div>
        <div className="modal-footer-content">
          <button className="styled-button" disabled={isLoading} onClick={() => handleAction(onCancel)}>
            {cancelLabel ?? 'Cancel'}
          </button><button className="styled-button" disabled={isLoading || confirmDisabled} onClick={() => handleAction(onConfirm)}>
            {confirmLabel ?? 'Confirm'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
